import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import { createTracker } from 'redux-segment';
import { pageMapper } from '@surfline/web-common/dist/segment';

import user from '../reducers/user';
import login from '../reducers/login';
import auth from '../reducers/auth';
import interactions from '../reducers/interactions';
import facebook from '../reducers/facebook';
import forgotPassword from '../reducers/forgotPassword';
import geo from '../reducers/geo';
import features from '../reducers/features';
import verifyEmail from '../reducers/verifyEmail';
import brand from '../reducers/brand';

export default (initialState, history) => {
  const enhancer = compose(
    applyMiddleware(
      thunkMiddleware,
      createTracker(pageMapper),
      routerMiddleware(history),
    ),
  );

  const reducer = combineReducers({
    brand,
    routing: routerReducer,
    auth,
    user,
    login,
    interactions,
    facebook,
    forgotPassword,
    form: formReducer,
    geo,
    flags: features,
    verifyEmail,
  });

  const store = createStore(reducer, initialState, enhancer);

  return store;
};
